<template>
    <div class="container-fluid d-flex flex-column">
        <div class="row flex-grow-0 d-sm-none qf-dashboard-menu-main">
            <div class="col-12">
                <div class="row align-items-center py-4">
                    <div class="col">
                        <router-link to="/dashboard" class="d-inline-block">
                            <img src="../../assets/logo2.png" alt="ТМ">
                        </router-link>
                    </div>
                    <div class="col">
                        <div class="qf-user-controls">
                            <div class="form-row align-items-center justify-content-end">
                                <div class="col d-flex flex-grow-0 justify-content-end">
                                    <router-link :to="{name: 'EditLoggedUser'}" class="qf-dashboard-user-link">
                                        <font-awesome-icon icon="user" size="2x"/>
                                    </router-link>
                                </div>
                                <div class="col flex-grow-0">
                                    <button type="button" class="qf-dashboard-user-link" @click="logout">
                                        <font-awesome-icon icon="sign-out-alt" size="2x"/>
                                        <!--                                        {{$ml.get('log_out')}}-->
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row"
                     v-click-outside="closeTopMenu">
                    <div class="col-12 position-relative">
                        <a href="#!" class="qf-home-menu-icon d-inline-block" :class="{change: showTopMenu}"
                           @click.prevent="showTopMenu = !showTopMenu">
                            <div class="bar1"></div>
                            <div class="bar2"></div>
                            <div class="bar3"></div>
                        </a>
                        <ul class="qf-dashboard-menu"
                            v-bind:class="{change: showTopMenu}"
                            v-if="!loading">
                            <li v-if="checkRoute('settings')"
                                :class="{'active-menu-item': checkRoute('settings')}">
                                <router-link :to="{name: 'EditLoggedUser'}"
                                             class="d-flex align-items-center py-2">
                                    <div class="flex-grow-0 mr-2 qf-h-32px">
                                        <font-awesome-icon icon="user" size="2x"/>
                                    </div>
                                    <div class="flex-grow-1 text-uppercase">
                                        {{userNames}}
                                    </div>
                                </router-link>
                            </li>
                            <li :class="{'active-menu-item': checkRoute('trademarks')}">
                                <router-link :to="{name: 'BrandReports'}" class="d-flex align-items-center py-2"
                                             :class="{'qf-first-rout-active': firstLineArray.indexOf($route.name) !== -1}">
                                    <div class="flex-grow-0 mr-2 qf-h-32px">
                                        <TrackBrandsIcon iconColor="#ffffff" width="32" height="32"/>
                                    </div>
                                    <div class="flex-grow-1 text-uppercase">
                                        {{$ml.get('track_trademarks')}}
                                    </div>
                                </router-link>
                            </li>
                            <li :class="{'active-menu-item': checkRoute('reports')}">
                                <router-link :to="{name: 'Reports'}" class="d-flex align-items-center py-2">
                                    <div class="flex-grow-0 mr-2 qf-h-32px">
                                        <ReportsIcon iconColor="#ffffff" width="32" height="32"/>
                                    </div>
                                    <div class="flex-grow-1 text-uppercase">
                                        {{$ml.get('reports')}}
                                    </div>
                                </router-link>
                            </li>
                            <li :class="{'active-menu-item': checkRoute('search')}"
                                v-if="(user.plan && user.plan.id >= 3) || user.roles[0] === 'ROLE_WRITE'">
                                <router-link to="/dashboard/search" class="d-flex align-items-center py-2">
                                    <div class="flex-grow-0 mr-2 qf-h-32px">
                                        <SearchInDatabaseIcon iconColor="#ffffff" width="32" height="32"/>
                                    </div>
                                    <div class="flex-grow-1 text-uppercase">
                                        {{$ml.get('search_in_database')}}
                                    </div>
                                </router-link>
                            </li>
                            <li :class="{'active-menu-item': checkRoute('owners')}"
                                v-if="user.roles[0] === 'ROLE_MAIN' && user.plan && user.plan.id >= 3">
                                <router-link to="/dashboard/owners" class="d-flex align-items-center py-2">
                                    <div class="flex-grow-0 mr-2 qf-h-32px">
                                        <OwnersListIcon iconColor="#ffffff" width="32" height="32"/>
                                    </div>
                                    <div class="flex-grow-1 text-uppercase">
                                        {{$ml.get('owners_list')}}
                                    </div>
                                </router-link>
                            </li>
                            <li :class="{'active-menu-item': checkRoute('users')}"
                                v-if="user.roles[0] === 'ROLE_MAIN' && user.plan && user.plan.id >= 3">
                                <router-link to="/dashboard/users" class="d-flex align-items-center py-2">
                                    <div class="flex-grow-0 mr-2 qf-h-32px">
                                        <UserListIcon iconColor="#ffffff" width="32" height="32"/>
                                    </div>
                                    <div class="flex-grow-1 text-uppercase">
                                        {{$ml.get('user_list')}}
                                    </div>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="row flex-grow-1">
            <div class="col qf-dashboard-content-main position-relative">
                <div class="qf-side-nav d-none d-sm-block"
                     :class="{change: showMenu}"
                     v-click-outside="closeSideMenu">
                    <div class="form-row">
                        <div class="col-12">
                            <router-link to="/dashboard" class="d-inline-block qf-logo-link">
                                <img src="../../assets/logo2.png" alt="ТМ">
                            </router-link>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-12">
                            <a href="#!"
                               class="qf-open-menu-link"
                               @click.prevent="showMenu = !showMenu">
                                <div class="flipper">
                                    <div class="front">
                                        <font-awesome-icon icon="chevron-right"/>
                                    </div>
                                    <div class="back">
                                        <font-awesome-icon icon="chevron-left"/>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-12">
                            <ul class="qf-dashboard-menu"
                                v-bind:class="{change: showMenu}"
                                v-if="!loading">
                                <li :class="{'active-menu-item': checkRoute('trademarks')}">
                                    <router-link :to="{name: 'BrandReports'}" class="d-flex align-items-center py-2"
                                                 :class="{'qf-first-rout-active': firstLineArray.indexOf($route.name) !== -1}">
                                        <div class="flex-grow-0 mr-2 qf-h-32px">
                                            <TrackBrandsIcon iconColor="#ffffff" width="32" height="32"/>
                                        </div>
                                        <div class="flex-grow-1 text-uppercase">
                                            {{$ml.get('track_trademarks')}}
                                        </div>
                                    </router-link>
                                </li>
                                <li :class="{'active-menu-item': checkRoute('reports')}">
                                    <router-link :to="{name: 'Reports'}" class="d-flex align-items-center py-2">
                                        <div class="flex-grow-0 mr-2 qf-h-32px">
                                            <ReportsIcon iconColor="#ffffff" width="32" height="32"/>
                                        </div>
                                        <div class="flex-grow-1 text-uppercase">
                                            {{$ml.get('reports')}}
                                        </div>
                                    </router-link>
                                </li>
                                <li :class="{'active-menu-item': checkRoute('search')}"
                                    v-if="(user.plan && user.plan.id >= 3) || user.roles[0] === 'ROLE_WRITE'">
                                    <router-link to="/dashboard/search" class="d-flex align-items-center py-2">
                                        <div class="flex-grow-0 mr-2 qf-h-32px">
                                            <SearchInDatabaseIcon iconColor="#ffffff" width="32" height="32"/>
                                        </div>
                                        <div class="flex-grow-1 text-uppercase">
                                            {{$ml.get('search_in_database')}}
                                        </div>
                                    </router-link>
                                </li>
                                <li :class="{'active-menu-item': checkRoute('owners')}"
                                    v-if="user.roles[0] === 'ROLE_MAIN' && user.plan && user.plan.id >= 3">
                                    <router-link to="/dashboard/owners" class="d-flex align-items-center py-2">
                                        <div class="flex-grow-0 mr-2 qf-h-32px">
                                            <OwnersListIcon iconColor="#ffffff" width="32" height="32"/>
                                        </div>
                                        <div class="flex-grow-1 text-uppercase">
                                            {{$ml.get('owners_list')}}
                                        </div>
                                    </router-link>
                                </li>
                                <li :class="{'active-menu-item': checkRoute('users')}"
                                    v-if="user.roles[0] === 'ROLE_MAIN' && user.plan && user.plan.id >= 3">
                                    <router-link to="/dashboard/users" class="d-flex align-items-center py-2">
                                        <div class="flex-grow-0 mr-2 qf-h-32px">
                                            <UserListIcon iconColor="#ffffff" width="32" height="32"/>
                                        </div>
                                        <div class="flex-grow-1 text-uppercase">
                                            {{$ml.get('user_list')}}
                                        </div>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row d-none d-sm-flex pt-3 pb-2">
                    <div class="col-12">
                        <div class="row align-items-center">
                            <div class="col d-flex flex-grow-1 justify-content-end">
                                <router-link :to="{name: 'EditLoggedUser'}" class="qf-dashboard-user-link">
                                    <font-awesome-icon icon="user" size="2x"/>
                                </router-link>
                            </div>
                            <div class="col flex-grow-0">
                                <button type="button" class="btn btn-outline-dark text-uppercase" @click="logout">
                                    {{$ml.get('log_out')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row pb-5">
                    <div class="col-12">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dashboard",
        computed: {
            user() {
                return this.$store.state.loggedUser
            },
            userNames() {
                return this.$store.state.loggedUser.first_name + ' ' + this.$store.state.loggedUser.last_name
            }
        },
        data() {
            return {
                firstLineArray: [
                    'BrandReports', 'AddBrand', 'EditBrand', 'BrandDetails'
                ],
                loading: true,
                showMenu: false,
                showTopMenu: false,
            }
        },
        beforeMount() {
            this.$store.dispatch('me').then(() => {
                this.loading = false;
            }).catch(error => {
                if (error.status === 401) {
                    this.logout();
                }
            })
        },
        beforeRouteUpdate(to, from, next) {
            this.showMenu = false;
            this.showTopMenu = false;
            next();
        },
        methods: {
            logout() {
                this.$store.dispatch('logout');
            },
            checkRoute(routeType) {
                let result = false;
                switch (routeType) {
                    case 'trademarks':
                        result = ['BrandReports', 'AddBrand', 'EditBrand', 'BrandDetails'].includes(this.$route.name);
                        break;
                    case 'reports':
                        result = ['Reports', 'ReportDetails', 'SingleReport'].includes(this.$route.name);
                        break;
                    case 'search':
                        result = ['SearchInDatabase', 'SingleSearchResult'].includes(this.$route.name);
                        break;
                    case 'owners':
                        result = ['OwnersList'].includes(this.$route.name);
                        break;
                    case 'users':
                        result = ['UserList', 'AddUser', 'EditUser'].includes(this.$route.name);
                        break;
                    case 'settings':
                        result = ['EditLoggedUser', 'UpgradePlan'].includes(this.$route.name);
                        break;
                }
                return result
            },
            closeSideMenu() {
                if (this.showMenu) {
                    this.showMenu = false;
                }
            },
            closeTopMenu() {
                if (this.showTopMenu) {
                    this.showTopMenu = false;
                }
            }
        }
    }
</script>

<style scoped>
    .qf-dashboard-user-link {
        border: 2px solid #211f20;
        font-size: 10px;
        border-radius: 50%;
        display: block;
        width: 31px;
        height: 31px;
        text-align: center;
        padding: 4px 0px;
        transition: 0.1s all;
        background: transparent;
    }

    .qf-dashboard-menu-main .qf-dashboard-user-link {
        border: 2px solid #f8f9fa;
        color: #f8f9fa;
    }

    .qf-dashboard-menu-main .qf-dashboard-user-link:hover,
    .qf-dashboard-menu-main .qf-dashboard-user-link:focus {
        background: #f8f9fa;
        border: 2px solid #f8f9fa;
        color: #211f20;
    }

    .qf-dashboard-user-link:hover {
        border: 2px solid #4D7B8F;
    }

    .qf-dashboard-user-header {
        border-bottom: 3px solid #211f20;
    }

    .qf-dashboard-menu-main {
        background-image: url("../../assets/background.jpg");
        background-size: cover;
        background-attachment: fixed;
        min-width: 300px;
    }

    .qf-dashboard-content-main {
        background-image: url("../../assets/background-signup.jpg");
        background-size: cover;
        background-attachment: fixed;
    }

    .qf-dashboard-head {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        min-height: 100%;
        width: 100%;
        overflow: hidden;
    }

    .qf-dashboard-head .qf-dashboard-bg:before {
        content: '';
        position: absolute;
        width: 100vw;
        height: 100%;
        background-image: url("../../assets/background.jpg");
        background-size: cover;
        background-attachment: fixed;
        top: 0;
        right: 0;
    }

    .qf-dashboard-head-line {
        overflow: hidden;
    }

    .qf-dashboard-head .qf-dashboard-line:before {
        content: '';
        position: absolute;
        width: 100vw;
        height: 100%;
        background-image: url("../../assets/background-signup.jpg");
        background-size: cover;
        background-attachment: fixed;
        top: 0;
        left: 0;
    }

    .qf-dashboard-head .qf-dashboard-line:after {
        content: '';
        position: absolute;
        width: 100vw;
        height: 3px;
        background-size: cover;
        background-attachment: fixed;
        top: 100px;
        left: 0;
        background: #211f20;
    }

    .qf-dashboard-user {
        line-height: 1.2;
    }

    .qf-dashboard-menu {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .qf-dashboard-menu > li {
        margin-bottom: 0;
        height: 0;
        opacity: 0;
        transition: 0.5s all;
    }

    .qf-dashboard-menu > li.active-menu-item {
        height: 48px;
        margin-bottom: 0;
        opacity: 1;
    }

    .qf-dashboard-menu.change > li.active-menu-item,
    .qf-dashboard-menu.change > li {
        margin-bottom: 20px;
        height: 48px;
        opacity: 1;
    }

    .qf-dashboard-menu > li.active-menu-item:last-child,
    .qf-dashboard-menu > li:last-child {
        margin-bottom: 0;
    }

    .qf-dashboard-menu > li > a {
        color: #f8f9fa;
        position: relative;
    }

    .qf-dashboard-menu > li > a > div {
        z-index: 10;
    }

    .qf-dashboard-menu > li > a:hover {
        text-decoration: none;
    }

    .qf-dashboard-menu > li.active-menu-item > a:before,
    .qf-dashboard-menu > li > a:hover:before {
        position: absolute;
        top: 0;
        right: -15px;
        content: '';
        background: rgba(0, 0, 0, 0.2);
        width: 100vw;
        height: 100%;
    }

    .qf-home-menu-icon {
        cursor: pointer;
        position: absolute;
        top: 8px;
        right: 15px;
        z-index: 100;
    }


    .qf-home-menu-icon > .bar1,
    .qf-home-menu-icon > .bar2,
    .qf-home-menu-icon > .bar3 {
        width: 35px;
        height: 2px;
        background-color: #f8f9fa;
        margin: 7px 0;
        transition: 0.4s;
    }

    .qf-home-menu-icon.change > .bar1 {
        -webkit-transform: rotate(-45deg) translate(-9px, 6px);
        transform: rotate(-45deg) translate(-9px, 6px);
    }

    .qf-home-menu-icon.change > .bar2 {
        opacity: 0;
    }

    .qf-home-menu-icon.change > .bar3 {
        -webkit-transform: rotate(45deg) translate(-9px, -7px);
        transform: rotate(45deg) translate(-6px, -4px);
    }

    .qf-user-controls {
        padding-top: 15px;
        padding-bottom: 15px;
    }

    @media (min-width: 576px) {
        .qf-user-controls {
            position: absolute;
            right: 15px;
            top: 30px;
            z-index: 500;
        }

        .qf-dashboard-content-main {
            padding-left: 85px;
            min-height: 485px;
        }

        .qf-side-nav {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            z-index: 100;
            width: 70px;
            background-image: url("../../assets/background.jpg");
            background-size: cover;
            background-attachment: fixed;
            padding: 15px 5px;
            transition: 0.5s all;
        }

        .qf-side-nav.change {
            width: 200px;
        }

        .qf-side-nav .qf-logo-link {
            width: 48px;
            display: block;
            overflow: hidden;
            margin-left: 5px;
            margin-top: 11px;
            margin-bottom: 12px;
            transition: 0.5s all;
        }

        .qf-side-nav .qf-logo-link > img {
            height: 40px;
            transition: 0.5s all;
        }

        .qf-side-nav.change .qf-logo-link {
            width: 180px;
            margin-bottom: 0;
            margin-top: 0;
        }

        .qf-side-nav.change .qf-logo-link > img {
            height: 63px;
        }

        .qf-side-nav .qf-open-menu-link {
            text-decoration: none;
            color: #f8f8f8;
            font-size: 32px;
            margin-left: 21px;
            margin-bottom: 20px;
            display: inline-block;
            perspective: 50px;
        }

        .qf-open-menu-link,
        .qf-open-menu-link .front,
        .qf-open-menu-link .back {
            width: 20px;
            height: 48px;
        }

        .qf-open-menu-link .flipper {
            transition: 0.5s all;
            transform-style: preserve-3d;
            position: relative;
        }

        .qf-open-menu-link .front,
        .qf-open-menu-link .back {
            backface-visibility: hidden;
            position: absolute;
            top: 0;
            left: 0;
        }

        .qf-open-menu-link .front {
            z-index: 2;
            transform: rotateY(0deg);
        }

        .qf-open-menu-link .back {
            transform: rotateY(180deg);
        }

        .qf-side-nav.change .qf-open-menu-link .flipper {
            transform: rotateY(-180deg);
        }

        .qf-dashboard-menu > li.active-menu-item,
        .qf-dashboard-menu > li {
            margin-bottom: 20px;
            height: 48px;
            opacity: 1;
        }

        .qf-dashboard-menu > li > a > div:first-child {
            margin-left: 15px;
        }

        .qf-dashboard-menu > li > a > div:last-child {
            max-width: 0;
            max-height: 48px;
            white-space: nowrap;
            overflow: hidden;
            opacity: 0;
            font-size: 0;
            padding-top: 1px;
            transition: 0.5s all;
        }

        .qf-side-nav.change .qf-dashboard-menu > li > a > div:last-child {
            max-width: 140px;
            opacity: 1;
            font-size: 12px;
        }

        .qf-dashboard-menu > li.active-menu-item > a:before,
        .qf-dashboard-menu > li > a:hover:before {
            right: -5px;
        }
    }

</style>
